
import { Component, Vue } from "vue-property-decorator";

import NavigationDrawer from "@/components/Shared/NavigationDrawer.vue";
import CallQueueBar from "@/components/Shared/CallQueueBar.vue";
import SideAlerts from "@/components/Shared/SideAlerts.vue";
import ConfirmDialog from "@/components/Shared/ConfirmDialog.vue";
import { initGoogleMaps, isCurrentUserInAnyRole } from "./utils";
import { Role } from "./models/Role";
import { isDaktelaEnabled, syncDaktelaEnabled } from "@/store/daktela";
import { eventBus, Events } from "@/utils/event-bus";

@Component({
  components: {
    NavigationDrawer,
    CallQueueBar,
    SideAlerts,
    ConfirmDialog,
  },
})
export default class App extends Vue {
  isMobile = false;

  Role = Role;

  get isNavMenuHidden() {
    return this.$route.meta?.isNavMenuHidden || false;
  }

  get showCallQueueBar(): boolean {
    return (
      !this.isNavMenuHidden &&
      isDaktelaEnabled() &&
      isCurrentUserInAnyRole([Role.Administrator, Role.Dispatcher])
    );
  }

  get backgroundColor() {
    return this.$vuetify.theme.currentTheme.primary;
  }

  mounted() {
    initGoogleMaps();
    syncDaktelaEnabled();
    eventBus.$on(Events.UserLoggedIn, this.syncDaktelaActivation);
    eventBus.$on(Events.UserLoggedOut, this.syncDaktelaActivation);
  }

  beforeDestroy() {
    eventBus.$off(Events.UserLoggedIn, this.syncDaktelaActivation);
    eventBus.$off(Events.UserLoggedOut, this.syncDaktelaActivation);
  }

  syncDaktelaActivation = () => {
    syncDaktelaEnabled();
  };

  isCurrentUserInAnyRole(roles: Role[]): boolean {
    return isCurrentUserInAnyRole(roles);
  }

  onResize() {
    this.isMobile = window.innerWidth < 768;
  }
}
